import React from "react";
import { Box } from "@mui/material";
import CopyrightNotice from "./CopyrightNotice";

function Footer() {
  return (
    <Box>
      <footer>
          <CopyrightNotice
            startYear={2022}
            href="https://www.ferrero.it/"
            company="Ferrero"
          />
      </footer>
    </Box>
  );
}

export default Footer;
